module.exports = __webpack_public_path__ + "static/media/confined-space.a4118c43.jpg";